import _ from 'lodash';
import {
  FETCH_CART,
  CREATE_CART,
  DELETE_CART,
  UPDATE_CART,
} from './types';

export default function(state = {}, action) {
  switch (action.type) {
    case FETCH_CART:
      return action.payload;
    case CREATE_CART:
      return { ...state, ...action.payload };
    case DELETE_CART:
      return _.omit(state, action.payload);
    case UPDATE_CART:
      return { ...state, ...action.payload };
    default:
      return state;
  }

}



// WEBPACK FOOTER //
// ./src/data/carts/reducer.js